import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import NetworkManager from "../../app/managers/networkManager";
import { config } from "../../app/utils/config";
import { store } from "../../app/store/store";
import { showPopup } from "../../../src/containers/common/commonSlice";
import { setIsLoading } from "../../../src/containers/common/commonSlice";
import moment from "moment";
import { showSuccessToast } from "../../app/utils/helpers";


const initialState = {
    list: []
}

export const employmentPromisesSlice = createSlice({
    name: "employmentPromises",
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(getEmploymentPromises.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.list) {
                state.list = action.payload.responseData.list.map(item => ({
                    ...item,
                    request_date: item.request_date ? new Date(item.request_date) : null,
                    start_date: item.start_date ? new Date(item.start_date) : null,
                    sent_date: item.sent_date ? new Date(item.sent_date) : null
                })) || [];
            }
        });
        builder.addCase(addEmploymentPromise.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                showSuccessToast("Promesse d'embauche ajoutée avec succès");
            }
        });
        builder.addCase(updateEmploymentPromise.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                showSuccessToast("Promesse d'embauche mise à jour avec succès");
            }
        });
        builder.addCase(deleteEmploymentPromise.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                showSuccessToast("Promesse d'embauche supprimée avec succès");
            }
        });
    }
})

export const getEmploymentPromises = createAsyncThunk(
    "employmentPromises/getAll",
    async () => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.employmentPromises.getAll
            );
            return response;
        } catch (error) {
            return error;
        }
    }
);

export const addEmploymentPromise = createAsyncThunk(
    "employmentPromises/insert",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.employmentPromises.insert,
                body
            );
            return response;
        } catch (error) {
            return error;
        }
    }
);
export const updateEmploymentPromise = createAsyncThunk(
    "employmentPromises/update",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.employmentPromises.update,
                body
            );
            return response;
        } catch (error) {
            return error;
        }
    }
);
export const deleteEmploymentPromise = createAsyncThunk(
    "employmentPromises/delete",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.employmentPromises.delete,
                body
            );
            return response;
        } catch (error) {
            return error;
        }
    }
);

export const {

} = employmentPromisesSlice.actions
export default employmentPromisesSlice.reducer
